import React from "react";
import DayPicker, { DateUtils } from "react-day-picker";
import classNames from "classnames";
import { formatDateByDay } from "helpers/formatDate";

const Calendar = (props) => {
  const { onDayChange,onMonthChange, handleDayMouseEnter, currentDaysRange, disabledDays } =
    props;

  const handleDayClick = (day, { selected }) => {
    onDayChange(day, selected);
  };

  const renderDay = (day) => {
    const month = day.getMonth() + 1;
    const date = day.getDate();

    const { from, to } = currentDaysRange[1];

    const isDayBetween = DateUtils.isDayBetween(
      day,
      from || new Date(),
      to || new Date()
    );

    const isFirstSelectedDay =
      month === from?.getMonth() + 1 && date === from?.getDate();

    const isLastSelectedDay =
      month === to?.getMonth() + 1 && date === to?.getDate();

    const isSelectedSingleDay = formatDateByDay(from) === formatDateByDay(to);

    return (
      <div className="DayPicker-Day-Container">
        <div
          className={classNames("DayPicker-Day-Date", {
            "DayPicker-Day-Date__first-day":
              isFirstSelectedDay && !isSelectedSingleDay,
            "DayPicker-Day-Date__last-day":
              isLastSelectedDay && !isSelectedSingleDay,
            "DayPicker-Day-Date__day-between": isDayBetween,
          })}
        >
          {date}
        </div>
      </div>
    );
  };

  return (
    <DayPicker
      disabledDays={disabledDays}
      selectedDays={currentDaysRange}
      renderDay={renderDay}
      onDayClick={handleDayClick}
      onMonthChange={onMonthChange}
      onDayMouseEnter={handleDayMouseEnter}
    />
  );
};

export default Calendar;
